import { render, staticRenderFns } from "./WallImageSliderBlock.vue?vue&type=template&id=d4f2a834"
import script from "./WallImageSliderBlock.vue?vue&type=script&lang=js"
export * from "./WallImageSliderBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports